//--------------- IMPORTAÇÕES ---------------//
import { useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Loading } from "../../shared/components";
import { loadCostsService } from "./services";
import { GastosContext } from "./context/GastosContext";
import { LoadingContext } from "../../shared/context/LoadingContext"
import { Main } from "./components";



//--------------- EXPORTAÇÃO DA PÁGINA GASTOS GRUPO
export default function Gastos() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { costs, setCosts } = useContext(GastosContext); // Estado que armazena a lista de Gastos existentes
    const { isLoading, setIsLoading } = useContext(LoadingContext); // Estado que armazena se a tela de carregamento está aparecendo ou não (inicia aparecendo)



    //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
    useEffect(() => {
        handleLoadCosts();
    }, []);



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GASTOS ---------------//
    // Responsável por requisitar à API os Gastos existentes
    // Armazena no Estado "gastos" a lista retornada pela API
    async function handleLoadCosts() {
        setIsLoading(true);
        const response = await loadCostsService();
        if (response) {
            setCosts(response.data.map(item => ({ ...item, valor: item.valor || "" })));
        }
        setIsLoading(false);
    }



    //--------------- RETORNO CONDICIONAL DA PÁGINA GASTOS GRUPO ---------------//
    return (
        <>
            {isLoading || costs === null ? <Loading /> : <Main />}
        </>
    )
}